
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/resetPassword",
      function () {
        return require("private-next-pages/auth/resetPassword.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/resetPassword"])
      });
    }
  